import { ICheckboxFieldProps } from './BaseInputField/BaseInputField.types';
import CheckboxField from './InputTypes/CheckboxField';

const CreditCheckAgreementInput = (props: ICheckboxFieldProps) => {
    return (
        <CheckboxField
            {...props}
            required
            name='creditCheckAgreement'
            dataTestid='credit-check-agreement-checkbox'
            label='I authorize Viaero to obtain my credit history, which will not impact my credit rating.'
        />
    );
};

export default CreditCheckAgreementInput;
